import React from 'react'
import {ChevronLeftIcon, XMarkIcon} from "@heroicons/react/24/solid";
import {Link} from "react-router-dom";
import _ from "lodash";

const SearchBox = ({label, searchText, setSearchText}) => {

    const handleClearSearch = () => {
        setSearchText('');
    }

    const handleSearchText = (event) => {
        setSearchText(event.target.value);
    }

    return (
        <>
            <div className="flex justify-start">
                <div className="field-group-container">
                    <div className="field-container">
                        <input
                            placeholder={label}
                            type="text"
                            className="input-field-max pl-3"
                            id="searchText"
                            name="searchText"
                            value={searchText}
                            onChange={handleSearchText}>
                        </input>
                    </div>

                    {searchText &&
                        <button
                            onClick={() => handleClearSearch()}
                            className="rounded -ml-11 border-gray-500 bg-white text-gray-500 hover:bg-gray-500 hover:text-white">
                            <div className="p-1">
                                <XMarkIcon className="h-6 w-6"/>
                            </div>
                        </button>
                    }
                </div>
            </div>
        </>
    )
}

export default SearchBox
